import React, {useEffect, useState, useContext} from 'react'
import { Result } from 'antd';
import {
    Link,
  } from 'react-router-dom';

import {useFetch} from '@utils'
import { appContext } from '../AppContext';

export default function EmailValidatePage() {

    const [doFetch] = useFetch();
    const [result, setResult] = useState(undefined)
    const [appState] = useContext(appContext);

    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('token');

    useEffect(() => {
        var uri_enc = encodeURIComponent(myParam)

        const url = `/api/Account/ValidateEmail?token=${uri_enc}`;

        doFetch(url)
            .then((response) => {
                if(response.isSuccess) {
                    setResult(true);
                    return;
                }
                setResult(false);
            })
    },     //eslint-disable-next-line
    [])

    if(result === undefined) {
        return <p>Loading...</p>
    }

    if(!result) {
        return (     
            <Result
                status="error"
                title="Email not verified"
                subTitle="Please try again or contact someone from the larpTOM team."
            />
        )
    }

    return (
        <div className={"main"}>
            <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo"/>
            <h2>Validate email</h2>
            <Result
                status="success"
                title="Email verified"
                subTitle="You can now login"
                extra={[
                    <Link to={`/${appState.appName}/login`}>Login</Link>
                ]}
                />
        </div>
    )
}